<div class="language-selector-wrapper">
  <label class="language-label" *ngIf="showLabel">
    {{ 'Set your preferred language' | translate }}
  </label>

  <div class="select-wrapper">
    <button type="button" class="language-selector" (click)="toggleDropdown()" [attr.aria-expanded]="isOpen">
      {{ getSelectedDisplayName() }}
    </button>

    <ul class="dropdown-options" *ngIf="isOpen">
      <li
        *ngFor="let lang of displayLanguages"
        class="dropdown-option"
        [class.selected]="lang.code === selectedLanguage"
        (click)="selectLanguage(lang.code)"
      >
        {{ lang.displayName }}
      </li>
    </ul>
  </div>
</div>
